import React, { useRef } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";

import { useNavigate } from "react-router";
import LazyImage from "../../../components/Loading/lazyImage";
import { VipList } from "../vipList";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const VipListCard = ({ customNavigate }) => {
  const { t } = useTranslation();
  const i18n = (key, props) => t(`vip.${key}`, { ...props });

  const navigate = useNavigate();

  const vipList = useSelector((state) => state.isVipDetail);
  const memberData = useSelector((state) => state.isMemberInfo);
  const { vipInfo } = memberData;

  const splideRef = useRef();

  const slideToNext = () => {
    if (splideRef.current) {
      const splide = splideRef.current.splide;
      const currentIndex = splide.index;
      const newIndex = currentIndex + 1;

      splide.go(newIndex);
    }
  };
  const slideToBack = () => {
    if (splideRef.current) {
      const splide = splideRef.current.splide;
      const currentIndex = splide.index;
      const newIndex = currentIndex - 1;

      splide.go(newIndex);
    }
  };

  const currentDate = new Date();
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const currentMonth = monthNames[currentDate.getMonth()];
  //獲取當月月份，把他轉成英文

  return (
    <div className="flex flex-col gap-[10px]">
      <section className="flex items-center justify-between">
        <span className="text-transaction-card-text dark:text-base-light-white font-medium text-lg">
          {i18n(currentMonth)} {i18n("progress")}
        </span>
        <div className="flex items-center gap-[10px]">
          <div
            onClick={() => {
              slideToBack();
            }}
            className="cursor-pointer w-[20px] h-[20px] rounded-[5px] dark:bg-base-light-dark bg-transaction-card flex items-center justify-center text-transaction-card-text dark:text-base-light-white text-lg"
          >
            <IoIosArrowBack />
          </div>
          <div
            onClick={() => {
              slideToNext();
            }}
            className="cursor-pointer w-[20px] h-[20px] rounded-[5px] dark:bg-base-light-dark bg-transaction-card flex items-center justify-center text-transaction-card-text dark:text-base-light-white text-lg"
          >
            <IoIosArrowForward />
          </div>
        </div>
      </section>
      <section>
        <Splide
          ref={splideRef}
          options={{
            pagination: false,
            arrows: false,
            drag: "free",
            perPage: 3,
            perMove: 1,
            gap: 15,
            lazyLoad: "nearby",
            dragMinThreshold: {
              mouse: 0,
              touch: 10,
            },
          }}
        >
          {vipList.map((vip, index) => {
            return (
              <SplideSlide>
                <div
                  onClick={() => {
                    if (customNavigate) {
                      navigate(`${customNavigate}/${index}`);
                    } else {
                      navigate(`${index}`);
                    }
                  }}
                  className="cursor-pointer hover:bg-hover-transaction-card dark:bg-base-light-dark bg-transaction-card rounded-[5px] py-[10px] px-[6px] flex flex-col items-center justify-center gap-[4px]"
                >
                  <LazyImage
                    className="!w-[92px] !h-[92px] object-scale-down"
                    src={vip.icon}
                    loadingClassName={`!rounded-full`}
                  />
                  {/* <span className="text-xl font-semibold text-transaction-card-text dark:text-base-light-white text-lg">
                    {i18n(vip.label.toLowerCase())}
                  </span> */}
                  <span className="text-sm tracking-tighter text-transaction-text dark:text-base-light-white text-lg">
                    {" "}
                    {vipInfo?.vip_lv_now >= index
                      ? i18n("completed")
                      : i18n("inProgress")}
                  </span>
                </div>
              </SplideSlide>
            );
          })}
        </Splide>
      </section>
    </div>
  );
};

export default VipListCard;
